import { FC } from 'react';
import { connect } from 'react-redux';
import { EditableText } from '@salecycle/ui-component-library';
import styled from 'styled-components';

import { Ruleset } from 'entities/campaign';
import { Actions as RulesetActions, Selectors as RulesetSelectors } from 'sections/campaigns/state/rulesets';
import { State } from 'store';
import { useTranslation } from 'react-i18next';

const StyledRulesetName = styled.div`
  margin-bottom: 1rem;
`;

interface OwnProps {
  rulesetId: string;
}

interface StateProps extends OwnProps {
  name: string;
}

interface DispatchProps {
  editRuleset: (rulesetId: string, changes: Ruleset) => void;
}

export type Props = StateProps & DispatchProps;

export const RulesetName: FC<Props> = props => {
  const { t } = useTranslation('campaigns');
  const onChange = (name: string) => props.editRuleset(props.rulesetId, { name });

  return (
    <StyledRulesetName>
      <EditableText
        ariaLabel={t('campaigns:editor.rulesets.rulesetName.label')}
        placeholder={t('campaigns:editor.rulesets.rulesetName.placeholder')}
        value={props.name}
        onChange={onChange}
        spacingBelow={false}
        inputTestId="RulesetNameInput"
      />
    </StyledRulesetName>
  );
};

const mapState = (state: State, ownProps: OwnProps): StateProps => ({
  ...ownProps,
  name: RulesetSelectors.getUpdatedEntity(state, ownProps.rulesetId).name,
});

const actionCreators: DispatchProps = {
  editRuleset: RulesetActions.updateLocal,
};

export default connect(mapState, actionCreators)(RulesetName);
